import axios from "axios";
import type { 
    AxiosInstance, 
    AxiosResponse,
    AxiosError 
} from 'axios';
import { SERVER_BASE_URL } from '../../ConfigFiles/Routes/api_routes';

/**
 * Production-ready Axios instance
 * Includes timeouts and centralized error handling
 */
const apiClient: AxiosInstance = axios.create({
    baseURL: SERVER_BASE_URL,
    withCredentials: true,
    timeout: 10000, // 🎯 Best Practice: Don't let requests hang forever
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

apiClient.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: unknown) => {
        const isDevelopment = window.location.hostname === 'localhost';

        // 🎯 THE "STURDY" FIX
        // We tell TS: "Treat this as an AxiosError from the start."
        if (axios.isAxiosError(error)) {
            // We create a local alias. This breaks the "never" logic loop.
            const apiError = error as AxiosError; 

            if (!axios.isCancel(apiError)) {
                console.error('API Request Failed:', {apiError});
            }

            if (apiError.response?.status === 401) {
                if (!isDevelopment && !window.location.pathname.includes('/login')) {
                    window.location.href = '/login?reason=unauthorized'; 
                }
            }
        }

        return Promise.reject(error); 
    }
);
export default apiClient;